import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useMutation } from '@pv/common/hooks';
import { EditablePanel, Fields } from '@pv/common/components';
import { updateOrganizationMutation } from '../graphql';
import { PlanSetsTable } from './PlanSetsTable';
import { HubspotOwners } from './HubspotOwners';
export const InfoPanel = ({ organization, availablePlanSets }) => {
  const resetValues = () => {};
  const [name, setName] = useState('');
  const [discount, setDiscount] = useState(
    Math.round((organization?.discount || 0.0) * 100 * 100) / 100
  );

  const [addOnDiscount, setAddOnDiscount] = useState(
    Math.round((organization?.addOnDiscount || 0.0) * 100 * 100) / 100
  );
  const [planSetId, setPlanSetId] = useState(organization?.planSet?.id || '');
  const [hubspotDealId, setHubspotDealId] = useState(
    organization?.hubspotDealId || ''
  );

  const [stripeCustomerId, setStripeCustomerId] = useState(
    organization?.stripeCustomerId || ''
  );

  const availablePlanSetVals = availablePlanSets?.map((planSet) => [
    planSet.id,
    planSet.name,
  ]);

  useEffect(() => {
    setName(organization?.name || '');
    setDiscount(Math.round((organization?.discount || 0.0) * 100 * 100) / 100);
    setAddOnDiscount(
      Math.round((organization?.addOnDiscount || 0.0) * 100 * 100) / 100
    );
    setPlanSetId(organization?.planSet?.id);
    setHubspotDealId(organization?.hubspotDealId);
    setStripeCustomerId(organization?.stripeCustomerId || '');
  }, [organization]);

  const [updateOrganization, { loading: updateLoading }] = useMutation(
    updateOrganizationMutation,
    {
      onNoErrorsCompleted: () => {
        enqueueSnackbar('Updated Organization');
      },
    }
  );

  const loading = updateLoading;

  const onSave = () => {
    const input = {
      id: organization.id,
      name,
      planSetId: planSetId,
      discount: discount ? discount / 100 : null,
      addOnDiscount: addOnDiscount ? addOnDiscount / 100 : null,
      hubspotDealId: hubspotDealId,
      stripeCustomerId: stripeCustomerId.trim() || null,
    };
    const variables = { input };

    updateOrganization({ variables });
  };

  return (
    <div>
      <EditablePanel
        name="organization"
        onSave={onSave}
        onClear={resetValues}
        loading={loading}
        title="Organization Info"
      >
        {({ editing }) => (
          <Grid container spacing={2}>
            {organization.hubspotDealId && (
              <Grid item xs={12}>
                <HubspotOwners organizationId={organization.id} />
              </Grid>
            )}
            <Grid item xs={6}>
              <Fields.PvTextField
                disabled={!editing}
                required
                label="Name"
                value={name || ''}
                onChange={(e) => setName(e.target.value)}
                name="name"
              />
            </Grid>
            <Grid item xs={6}>
              <Fields.PvPercentageField
                disabled={!editing}
                fullWidth
                label="Discount to be applied to all venues"
                name="discount"
                helperText="Discounts to apply to Basic, Pro, Premium, and Enterprise plans"
                value={discount || 0}
                onChange={(e) => setDiscount(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <Fields.PvTextField
                disabled={true}
                label="Billing Email"
                value={organization.billingEmail || ''}
                name="email"
              />
            </Grid>

            <Grid item xs={6}>
              <Fields.PvPercentageField
                disabled={!editing}
                fullWidth
                label="Add-on Discount"
                name="add-on-discount"
                helperText="Discount for add-ons (i.e. Floor Plans)"
                value={addOnDiscount || 0}
                onChange={(e) => setAddOnDiscount(e.target.value)}
              />
            </Grid>

            <Grid item xs={6}>
              <Fields.PvDropDown
                disabled={!editing}
                vals={availablePlanSetVals}
                label="Plan Set"
                name="plan-set"
                value={planSetId || ''}
                onChange={(e) => setPlanSetId(e.target.value)}
                helperText="Plan Sets are for orgs that have made a deal with sales for a specific set of prices"
              />
            </Grid>
            <Grid item xs={6}>
              <Fields.PvTextField
                disabled={!editing}
                label="Hubspot Deal ID"
                value={hubspotDealId || ''}
                name="hubspot-deal-id"
                helperText="The id is the 11-digit number which is the last part of the hubspot deal URL"
                onChange={(e) => setHubspotDealId(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <Fields.PvTextField
                disabled={!editing}
                label="Stripe Customer ID"
                value={stripeCustomerId || ''}
                name="stripe-customer-id"
                onChange={(e) => setStripeCustomerId(e.target.value)}
              />
            </Grid>
          </Grid>
        )}
      </EditablePanel>
      <PlanSetsTable planSets={availablePlanSets} />
    </div>
  );
};
